"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermSwitcher = void 0;
var object_service_1 = require("@services/object-service");
var settings_service_1 = require("@services/settings.service");
var lodash_1 = require("lodash");
var rxjs_1 = require("rxjs");
/**
 * Term switcher is a component that returns you the offerings that fall into a specific criteria
 * e.g. 6m, 12m, 1m membership.
 */
var TermSwitcher = /** @class */ (function () {
    function TermSwitcher() {
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.termPropertyNameUsedForSwitch = 'termValue';
        this.termChanged = new rxjs_1.ReplaySubject(1);
    }
    /**
     * Filters and returns offerings based on term switcher selection
     * @param offerings
     * @returns offerings
     */
    TermSwitcher.prototype.filterOfferingsAndTermsBySwitcherValue = function (offerings) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        // filter specific terms out
        if (Array.isArray((_b = (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.checkout) === null || _b === void 0 ? void 0 : _b.hideTermIds) && this.config.get.checkout.hideTermIds.length > 0) {
            for (var _i = 0, offerings_1 = offerings; _i < offerings_1.length; _i++) {
                var offer = offerings_1[_i];
                offer.terms = offer.terms.filter(function (term) { var _a, _b; return !((_b = (_a = _this.config.get) === null || _a === void 0 ? void 0 : _a.checkout) === null || _b === void 0 ? void 0 : _b.hideTermIds.includes(term.id.toString())); });
            }
        }
        if (Array.isArray((_d = (_c = this.config.get) === null || _c === void 0 ? void 0 : _c.checkout) === null || _d === void 0 ? void 0 : _d.whitelistTermIds) && this.config.get.checkout.whitelistTermIds.length > 0) {
            for (var _p = 0, offerings_2 = offerings; _p < offerings_2.length; _p++) {
                var offer = offerings_2[_p];
                offer.terms = offer.terms.filter(function (term) { var _a, _b; return (_b = (_a = _this.config.get) === null || _a === void 0 ? void 0 : _a.checkout) === null || _b === void 0 ? void 0 : _b.whitelistTermIds.includes(term.id.toString()); });
            }
        }
        if (Array.isArray((_f = (_e = this.config.get) === null || _e === void 0 ? void 0 : _e.checkout) === null || _f === void 0 ? void 0 : _f.hideTermNames) && this.config.get.checkout.hideTermNames.length > 0) {
            var hidden_1 = this.config.get.checkout.hideTermNames.map(function (name) { return name.toLowerCase(); });
            for (var _q = 0, offerings_3 = offerings; _q < offerings_3.length; _q++) {
                var offer = offerings_3[_q];
                offer.terms = offer.terms.filter(function (term) { return !hidden_1.some(function (h) { return term.name.toLowerCase().includes(h); }); });
            }
        }
        if (!((_j = (_h = (_g = this.module.references) === null || _g === void 0 ? void 0 : _g.termSwitcher) === null || _h === void 0 ? void 0 : _h.domElement) === null || _j === void 0 ? void 0 : _j.length)) {
            console.error('termswitcher not found');
            return offerings;
        }
        console.log('Term switcher is using the propery', this.termPropertyNameUsedForSwitch, 'and', this.termValueHasToMatch, 'to filter offerings:', JSON.parse(JSON.stringify(offerings)));
        var filteredOfferings = (0, lodash_1.cloneDeep)(offerings);
        var isOfferingFilter = ['name', 'recurringOffering'].includes((_l = (_k = this.config.get) === null || _k === void 0 ? void 0 : _k.checkout) === null || _l === void 0 ? void 0 : _l.termSwitcherAttribute);
        // NOTE: Termswitcher filters only offerings or terms but not both
        // Filter offerings by termswitcher value
        if (((_m = this.termPropertyNameUsedForSwitch) === null || _m === void 0 ? void 0 : _m.length) && isOfferingFilter) {
            offerings = filteredOfferings.filter(function (a) {
                return String(a[_this.termPropertyNameUsedForSwitch]).toLowerCase().includes(_this.termValueHasToMatch.toLowerCase());
            });
        }
        console.log('Term switcher is using the propery', this.termPropertyNameUsedForSwitch, 'and', this.termValueHasToMatch, 'to filter which results in remaining offerings:', JSON.parse(JSON.stringify(offerings)));
        // Filter terms by termswitcher value if not filtered by offerings yet
        if (((_o = this.termPropertyNameUsedForSwitch) === null || _o === void 0 ? void 0 : _o.length) && this.termValueHasToMatch && !isOfferingFilter) {
            for (var i = offerings.length - 1; i >= 0; i--) {
                var offer = offerings[i];
                // Filter out terms that don't match the term switcher value
                offer.terms = offer.terms.filter(function (term) { return String(term[_this.termPropertyNameUsedForSwitch]) === String(_this.termValueHasToMatch); });
                // Remove the offer if all terms were filtered out
                if (offer.terms.length === 0) {
                    offerings.splice(i, 1);
                    console.warn('Offering', offer.id, 'has no matched terms, removing it from term switcher', this.termPropertyNameUsedForSwitch, this.termValueHasToMatch);
                }
            }
        }
        return offerings;
    };
    /**
     * Prepare term switcher module
     * @param offerings
     */
    TermSwitcher.prototype.loadModule = function (offerings) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g;
        console.log("Loading termswitcher with offerings", offerings);
        if (!((_c = (_b = (_a = this.module.references) === null || _a === void 0 ? void 0 : _a.termSwitcher) === null || _b === void 0 ? void 0 : _b.domElement) === null || _c === void 0 ? void 0 : _c.length)) {
            console.error('termswitcher not found');
            return;
        }
        var termSwitcher = (_e = (_d = this.module.references) === null || _d === void 0 ? void 0 : _d.termSwitcher) === null || _e === void 0 ? void 0 : _e.domElement;
        var numberOfTerms = offerings.map(function (a) { return a.terms.length; }).reduce(function (partialSum, a) { return partialSum + a; }, 0);
        //If offerings.length === all terms.length there is literally no term to switch
        //Except we switch offerings which can be the case if you switch by offeringname
        if (numberOfTerms === offerings.length) {
            console.error('We have no terms to switch to therefore termswitcher is hidden', offerings.length);
        }
        //we have a termswitcher most probably you switch by termvalue (e.g. 6,12,1month membership)
        var termKey = ((_g = (_f = this.config.get) === null || _f === void 0 ? void 0 : _f.checkout) === null || _g === void 0 ? void 0 : _g.termSwitcherAttribute) || 'termValue';
        if (termKey === null || termKey === void 0 ? void 0 : termKey.length) {
            this.termPropertyNameUsedForSwitch = termKey;
        }
        var numberOfTabs = [];
        var tabs = termSwitcher.find('[data-set]');
        var allTerms = offerings
            .filter(function (a) { return a.terms.length; })
            .map(function (a) { return a.terms; })
            .flat();
        console.log('All term switcher tabs', tabs, ' and terms', allTerms);
        var _loop_1 = function (tab) {
            var attr = tab.getAttribute('data-set');
            var offeringTerm = undefined;
            var tabHasAtLeastOneTerm = allTerms.some(function (a) {
                offeringTerm = a[_this.termPropertyNameUsedForSwitch];
                return +a[_this.termPropertyNameUsedForSwitch] === +attr;
            });
            //try again
            if (offeringTerm === undefined) {
                tabHasAtLeastOneTerm = offerings.some(function (a) {
                    return a[_this.termPropertyNameUsedForSwitch].toLowerCase().includes(attr.toLowerCase());
                });
            }
            if (tabHasAtLeastOneTerm === false && tab) {
                // Remove tabs that have no terms to prevent confusion
                console.warn('Term switcher tab', attr, 'has no term, hiding it. Using filter key', this_1.termPropertyNameUsedForSwitch);
                tab.style.display = 'none';
            }
            else {
                console.info('Tab', attr, 'has existent offerings');
                numberOfTabs.push(tab);
            }
        };
        var this_1 = this;
        //Checks if a requested tab has a term if e.g. there is a tab 12m but no term with 12m it doesnt make sense to show the tab
        for (var _i = 0, _h = tabs.get(); _i < _h.length; _i++) {
            var tab = _h[_i];
            _loop_1(tab);
        }
        if (numberOfTabs.length === 1) {
            //If only one tab exists there is no sense to have a term switcher bcs where you want to switch to?
            //Therefore select the only tab that exists and hide it
            numberOfTabs[0].click();
            termSwitcher.hide();
            console.info('Term switcher has one tab only, hiding it');
        }
        //prepare tabs to be switched
        if (tabs.length) {
            //add event listeners to detect tab change
            tabs.on('click', function (event) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    if ((_b = (_a = event === null || event === void 0 ? void 0 : event.currentTarget) === null || _a === void 0 ? void 0 : _a.getAttribute('data-set')) === null || _b === void 0 ? void 0 : _b.length) {
                        this.termValueHasToMatch = event.currentTarget.getAttribute('data-set');
                        this.termChanged.next(this.termValueHasToMatch);
                    }
                    return [2 /*return*/];
                });
            }); });
            //find default selected tab / term
            var currentlyActive = termSwitcher.find('.w--current[data-set]');
            if (currentlyActive === null || currentlyActive === void 0 ? void 0 : currentlyActive.length) {
                this.termValueHasToMatch = currentlyActive.attr('data-set');
                this.termChanged.next(this.termValueHasToMatch);
            }
        }
        else if (this.config.get.environment === 'dev') {
            console.info('You have defined a termswitcher but no tabs. Please add data-set="termvalue". If you want to change the "termvalue" add a data-term-key to your app Termswitcher object');
        }
    };
    return TermSwitcher;
}());
exports.TermSwitcher = TermSwitcher;
